<script setup lang="ts">
import { useFooterType } from '~/composables/useFooterType';

const route = useRoute();
const { isGrayFooterPage: checkIsGrayFooterPage } = useFooterType();
const isGrayFooterPage = computed(() => checkIsGrayFooterPage(route.path));
</script>

<template>
  <footer v-if="isGrayFooterPage" class="gray-footer">
    <p class="mb-16 flex justify-start">
      <a href="https://www.nhk-book.co.jp/" target="_blank" rel="noopener"
        ><Img src="/images/ranking/footer/footer_logo_01.svg" alt="NHK出版"
      /></a>
    </p>
    <p class="text-center text-xs">Copyright NHK Publishing, Inc.</p>
  </footer>

  <footer v-else class="common-footer">
    <small class="text-sm leading-5"> Copyright NHK Publishing, Inc. </small>
  </footer>
</template>

<style scoped>
.gray-footer {
  @apply bg-[#e9e9ea] px-4 py-6;
}

.common-footer {
  @apply grid items-end py-4 text-center;
}
</style>
